import React from "react";
import { useTranslation } from "react-i18next";
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import config from '../../config';
import Icon from "../../libraries/icons";
import { capitalize } from "../../libraries/utils";

export default function PurchaseElement({ purchase, ...rest }) {
  const { t, i18n } = useTranslation();
  if(purchase.json_data.pharmacy.json_data){
    return (
      <div key={rest.key}>
        wrong data
      </div>
        )
  }
  
  const {created_at: fecha} = purchase
  const { name: pharmacyName, json_data: pharmacyData, } = purchase.json_data.pharmacy;
  const prescription_medicaments = purchase.json_data.prescription_medicaments;
  const prescriptions = purchase.json_data.prescriptions;
  const medicaments = purchase.json_data.medicaments;
  const medicaments_count = prescription_medicaments.length + medicaments.length;


  return (
    <div key={rest.key}>
      <div className="flex text-base-content">
        <div className="mr-3 text-center">
        <div className="avatar w-16 h-16">
            <img src={purchase.json_data.pharmacy.logo_picture} className="" alt="profile img" />
          </div>
          <small className="text-gray-400 text-2xs">#{purchase.id.substring(0,8)}</small>
        </div>
        <div className="w-full">
          <div className="flex justify-between leading-tight">
            <div className="mb-4">
              {pharmacyName && (
                <h4 className="text-primary">{capitalize(pharmacyName)}</h4>
              )}
              {pharmacyData && pharmacyData.address && (
                <small className="text-gray-500">{capitalize(pharmacyData.address.direccion)}</small>
              )}
            </div>
            {fecha && <small className="text-gray-500 mt-1"> {t("timeRemains", { date: new Date(fecha) }).replace(config.TRANSLATE.TIME_REMAINS,"")}</small>}
          </div>
          <div className="flex justify-between items-end mt-2">
          <div>
              {medicaments_count !== null && <small className="w-full block mb-1"><Icon className="h-4 w-4 mr-1 inline-block text-success" name="pills" /> {medicaments_count} medicamentos</small>}
              {prescriptions && <small className="w-full block mb-1"> <Icon className="h-4 w-4 mr-1 inline-block text-success" name="clipboard_list" />{prescriptions.length} prescipción</small>}
            </div>
            {
              purchase.status === 'open' &&
              <p className="badge badge-primary">{purchase.json_data?.location ? "Envio pendiente" : "Retiro pendiente"}</p>
            }
            {
              purchase.status === 'canceled' &&
              <p className="badge badge-error badge-outline">Cancelada</p>
            }
            {
              purchase.status === 'completed' &&
              <p className="badge badge-success badge-outline">Recibida</p>
            }
            
          </div>
        </div>
      </div>
    </div>
  );
}
